import React from 'react'
import WelcomeToPYW from 'components/WelcomeToPYW'
import ImageBanner from 'components/ImageBanner'
import { useTranslation, Trans } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { colors, breakpoints } from 'globalStyles'
import GuestButton from 'components/GuestButton'
import Cart from 'assets/svg/dolly.svg'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  margin-bottom: 42px;
  @media ${breakpoints.xxs} {
    max-width: 319px;
  }
`

const SubContainer = styled.div`
  width: 600px;
  margin-top: 32px;
  text-align: center;
  @media ${breakpoints.tablet} {
    margin-top: 20px;
  }
  @media ${breakpoints.phone} {
    margin-top: -8px;
    max-width: 328px;
  }
`
const BlueContainer = styled.div`
  background-color: ${colors.sky_blue};
  height: 244px;
  margin-top: 24px;
  padding: 24px 16px;
  height: auto;
  @media ${breakpoints.tablet}, ${breakpoints.desktop} {
    padding: 24px;
  }
`

const StyledImg = styled.img`
  margin-top: 24px;
`
const StyledDiv = styled.div`
  margin-top: 24px;
  width: 296px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  @media ${breakpoints.tablet}, ${breakpoints.desktop} {
    width: 552px;
  }
`

const StyledButton = styled.button`
  margin-top: 24px;
  width: 296px;
  height: 50px;
  background-color: ${colors.primary_blue};
  border: 1px solid ${colors.primary_blue};
  border-radius: 4px;
  color: ${colors.primary_white};
  @media ${breakpoints.tablet}, ${breakpoints.desktop} {
    width: 552px;
  }
  &:hover {
    background-color: ${colors.primary_dark_blue};
    border-color: ${colors.primary_dark_blue};
  }
`
const StyledLoginDiv = styled.div`
  margin-top: 24px;
  text-align: center;
  justify-self: anchor-center;
  font-size: 18px;
  line-height: 20px;
`

const LoginLink = styled.a.attrs({
  id: 'login-link',
  rel: 'noreferrer',
  href: '#',
})`
  color: ${colors.primary_blue};
  font-weight: 600;
  &:hover {
    color: ${colors.text_link_hover};
  }
`

const HomePage = () => {
  const { t, i18n } = useTranslation()
  const { language } = i18n
  const navigate = useNavigate()
  const onClickRegister = (e) => {
    e.preventDefault()
    navigate(`/rs/tr/${language}/register`, {
      replace: true,
    })
  }
  const onClickLogin = (e) => {
    e.preventDefault()
    navigate(`/rs/tr/${language}/login`, {
      replace: true,
    })
  }
  return (
    <Container>
      <ImageBanner shipmentStatus="out_for_delivery" />
      <SubContainer>
        <WelcomeToPYW />
        <BlueContainer>
          <StyledImg src={Cart} alt="Cart" />
          <StyledDiv>{t('landing_page.register_and_manage')}</StyledDiv>
          <StyledButton onClick={onClickRegister}>{t('landing_page.register_now')}</StyledButton>
        </BlueContainer>
        <StyledLoginDiv>
          <Trans
            t={t}
            i18nKey="landing_page.have_account"
            components={[<LoginLink onClick={onClickLogin} />]}
          />
        </StyledLoginDiv>
        <GuestButton isSrcLandingPage />
      </SubContainer>
    </Container>
  )
}

export default HomePage
